import { debounce } from "lodash";
import * as React from "react";
import { connect } from "react-redux";

import { Button, Grid, Input, InputOnChangeData, Table } from "semantic-ui-react";

import { isSystemAdminUser } from "@teamprevent/common/auth/roles";
import { CurrentUser } from "@teamprevent/common/auth/roles";
import { CustomerSraDepartmentDetailModel } from "@teamprevent/common/customerSraDepartment/model";

import { SelectorState, customerSraDepartmentsSelector } from "../selectors";

import { Link, replace } from "redux-little-router";

interface AllProps {
    customerSraDepartments: CustomerSraDepartmentDetailModel[];
    path: string;
    name: string;
    currentUser: CurrentUser;
}

interface AllDispatchProps {
    onFilterValueChange: (name: string) => void;
}

interface State {
    name: string;
}

export class AllUnconnected extends React.Component<AllProps & AllDispatchProps, State> {
    private debouncedUpdateFilter = debounce((value: string) => this.props.onFilterValueChange(value), 200);

    constructor(props: AllProps & AllDispatchProps) {
        super(props);
        this.onFilterValueChange = this.onFilterValueChange.bind(this);
        this.state = {
            name: props.name
        };
    }

    public render() {
        return (
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column width={14}>
                        <h1>SRA Departments</h1>
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="right">
                        {isSystemAdminUser(this.props.currentUser) && <Button icon="add" content="Create" as={Link} href={`${this.props.path}/create`} />}
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Name</Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell>
                                        <Input
                                            value={this.state.name}
                                            onChange={this.onFilterValueChange}
                                            icon="search"
                                            placeholder="Search..."
                                            size="mini"
                                        />
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.props.customerSraDepartments && this.props.customerSraDepartments
                                    .map(customerSraDepartment => (
                                        <Table.Row key={customerSraDepartment.id}>
                                            <Table.Cell>
                                                <Link href={`${this.props.path}/${customerSraDepartment.id}`}>
                                                    {customerSraDepartment.name}
                                                </Link>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }

    private onFilterValueChange(event: any, { value }: InputOnChangeData) {
        this.setState({ name: value });
        this.debouncedUpdateFilter(value);
    }
}

function mapStateToProps(state: SelectorState): AllProps {
    return {
        path: state.router.pathname,
        customerSraDepartments: customerSraDepartmentsSelector(state),
        name: state.router.query.name || "",
        currentUser: state.currentUser
    };
}

function mapDispatchToProps(dispatch: any): AllDispatchProps {
    return {
        onFilterValueChange: value => dispatch(replace({ pathname: "", query: { name: value } }))
    };
}

export const All = connect(mapStateToProps, mapDispatchToProps)(AllUnconnected);
